/*
 * @Author: Teemo Ding
 * @Date: 2021-11-30 09:08:51
 * @LastEditTime: 2021-12-02 16:29:42
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/additionalItem.ts
 */
import { post } from 'src/tools/server';
export const saveAdditionalItemRequest = (data) => {
  return post(`/portal/order/additionalItemRequest/save`, data, {});
};

export const approveAdditionalItemRequest = (data) => {
  return post(`/portal/order/additionalItemRequest/approve`, data, {});
};

export const rejectAdditionalItemRequest = (data) => {
  return post(`/portal/order/additionalItemRequest/reject`, data, {});
};
